module.exports = __webpack_public_path__ + "static/app-softwareentwicklung-ad4d14efe8ae8d784e4e99042f1339fc.png";